import React, { useMemo } from 'react';
import propTypes from 'prop-types';
import useCurrentCondominiumContext from '../../hooks/useContext';

export default function RestrictedContainer({ children, role, permission }) {
  const { role: currentRole, permission: currentPermission } = useCurrentCondominiumContext();

  const hasAccess = useMemo(() => {
    if (currentRole === 'janitor') return true;

    if (role !== 'any' && currentRole !== role) return false;

    switch (permission) {
      case 'vote':
        return currentPermission === 'vote';
      case 'comment':
        return ['vote', 'comment'].includes(currentPermission);
      case 'view':
        return ['vote', 'comment', 'view'].includes(currentPermission);
      default:
        return false;
    }
  }, [currentRole, currentPermission, role, permission]);

  if (!hasAccess) return <></>;
  return <>{children}</>;
}

RestrictedContainer.propTypes = {
  children: propTypes.any.isRequired,
  role: propTypes.oneOf(['any', 'dweller', 'janitor']),
  permission: propTypes.oneOf(['view', 'comment', 'vote']),
};

RestrictedContainer.defaultProps = {
  role: 'any',
  permission: 'view',
};
